import { RootState } from '@/store/main';

export const selectBtvChannelCategories = (state: RootState) => state.btvChannelCategories.btvChannelCategories;
export const selectIsLoadingBtvChannelCategories = (state: RootState) =>
  state.btvChannelCategories.loadingBtvChannelCategories;
